import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Register new patient
 */
export default async function registerNewPatient(
  userAccount: {
    email: string;
    password: string;
    invite_code?: string | null;
  },
  patientAccount: {
    first_name: string;
    last_name: string;
  },
) {
  const res = await fetchOrchidAPI("/api/users/v1/patient/account", {
    headers: { "content-type": "application/json" },
    method: "POST",
    body: JSON.stringify({
      user_in: userAccount,
      patient_in: patientAccount,
    }),
  });
  if (!res.ok) {
    throw new Error(
      `failed to create member account: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
